import { Grid, ServicesContainer } from './style';
import Title from '../Title';
import Reveal from '../Reveal';
import ServiceCard from '../ServiceCard';
import { SERVICES } from '../../constants';
import { getWhatsAppUrl } from '../../utils/whatsapp';

const Services = () => {
  return (
    <ServicesContainer id="services">
      <Reveal>
        <Title title="Nossos Serviços" />
        <Grid>
          {SERVICES.map((service) => (
            <ServiceCard
              key={service.id}
              title={service.title}
              Icon={service.Icon}
              href={getWhatsAppUrl(service.message)}
            />
          ))}
        </Grid>
      </Reveal>
    </ServicesContainer>
  );
};

export default Services;